import 'consumerweb-shim';
import 'adsinterceptor';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import uniq from 'lodash/uniq';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Row, Col } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import { DataContext } from '../../lib/context';
import Footer from 'marketing-components/dist/components/organisms/footer';
import Header from 'marketing-components/dist/components/organisms/header';
import {
  BodyText,
  Link,
  Alert,
  Icon,
  Button,
  Tooltip,
  HeadingText,
  CaptionText,
} from '@paypalcorp/pp-react';
import * as analytics from '../../lib/analytics';
import FAQBanner from '../../components/faqBanner';
import CharityLogo from '../../components/charityLogo';
import DonateBox from '../../components/donateBox';
import Benefits from '../../components/benefits/benefits';
import HubSocialShare from '../../components/HubSocialShare';
import CheckoutError from '../../components/checkoutError';
import SetPreferredHeart from '../../components/SetPreferredHeart/SetPreferredHeart';
import Spinner from '../../components/spinner/Spinner';
import content from '../../lib/i18n';
import SheetTrigger from '../../components/SheetTrigger';

import styles from './hub-npo.less';
import { getType, isPPGF } from '../../lib/charity';
import utils from '../../lib/utils';
import DonationTerms from '../../components/donation-terms';

import {
  HUB_PAGE_GROUP,
  HUB_PAGE_PROFILE_PAGE,
} from '../../lib/fptiTrackingVariables';

const i18n = content('hubProfilePage');

if (window.PAYPAL && window.PAYPAL.analytics) {
  window.PAYPAL.analytics.startClientErrorTracking();
}

class Page extends React.Component {
  static propTypes = {
    csrf: PropTypes.string,
    description: PropTypes.string,
    website_url: PropTypes.string,
    mission_area: PropTypes.array,
    resources: PropTypes.object,
    states: PropTypes.object,
    address: PropTypes.object,
  };

  static childContextTypes = {
    csrf: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);

    var initialState = {
      fptiInfo: {
        pgrp: HUB_PAGE_GROUP,
        page: HUB_PAGE_PROFILE_PAGE,
      },
      heartSelected: props.isThisCharityTheirPreferred,
      isMobile: false,
      heartError: false,
    };
    this.state = initialState;
  }

  componentDidMount() {
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.setState({
        isMobile: true,
      });
    }

    // to replace the default /signin href from marketing header
    // we need it to go back to npo page
    const marketingULButton = document.getElementById('ul-btn') || {};
    marketingULButton.href = this.props.unifiedLoginURL;
  }

  parseFPTIInfo = fptiData => {
    var nameValues = [];
    var pairs = decodeURIComponent(fptiData).split('&');
    var i;
    for (i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  getChildContext() {
    return {
      csrf: this.props.csrf,
    };
  }

  handleAnalyticsCategory = category => {
    analytics.trackLinkWithData(
      'CategoryClicked',
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      { category: category },
      'link'
    );
  };

  handleAnalyticsWebLink = () => {
    analytics.trackLink(
      'WebsiteLink',
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      'link'
    );
  };

  renderError = () => {
    if (this.props.donationInfo && this.props.donationInfo.donated === 0) {
      return (
        <CheckoutError
          i18n={i18n}
          fptiInfo={this.state.fptiInfo}
          cdnHost={this.props.cdnHost}
        />
      );
    }
  };

  renderHeader = () => {
    // https://github.paypal.com/MPPContentDevelopment/marketing-components#client
    const {
      content: { contentLoggedOut: content, config },
    } = JSON.parse(document.getElementById('data-header').innerHTML);

    const props = { content, config };

    return <Header {...props} />;
  };

  renderFooter = () => {
    const {
      content: { content: footerContent },
    } = JSON.parse(document.getElementById('data-footer').innerHTML);
    const { localeCountry } = footerContent;

    return (
      <Footer
        content={footerContent}
        localeCountry={localeCountry}
        flagHref={`https://www.${
          this.props.domain
        }/${localeCountry.toLowerCase()}/webapps/mpp/country-worldwide`}
      />
    );
  };

  renderDonationTerms = () => {
    const type = getType(this.props.charity);
    const charityContent = this.props.charityContent;

    return (
      <div className={styles.donationTermsStyle}>
        <DonationTerms
          i18n={i18n}
          type={type}
          donationTerms={charityContent.donationTerms}
        />
      </div>
    );
  };

  setPreferredFetch = () => {
    this.setState(
      {
        isLoading: true,
        heartError: false,
      },
      () => {
        fetch('/fundraiser/setPreferredCharity', {
          method: 'POST',
          body: JSON.stringify({
            _csrf: this.props.csrf,
            npid: this.props.nonprofit_id,
            setPreferred: !this.state.heartSelected,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(response => {
            if (response.status >= 400) {
              this.setState({
                isLoading: false,
                heartError: true,
              });
            } else {
              return response.json();
            }
          })
          .then(data => {
            const { setPreferredSuccess } = data;
            if (setPreferredSuccess) {
              this.setState({
                isLoading: false,
                heartSelected: !this.state.heartSelected,
              });
              analytics.trackLinkWithData(
                'npoHeartClicked',
                this.state.fptiInfo.pgrp,
                this.state.fptiInfo.page,
                {
                  npoHeartSelected: this.state.heartSelected,
                  crid: this.props.nonprofit_id,
                },
                'link'
              );
            } else {
              this.setState({
                isLoading: false,
                heartError: true,
              });
            }
          });
      }
    );
  };

  render() {
    const npid = this.props.nonprofit_id;
    const charityContent = this.props.charityContent;
    const formUrl = this.props.coBrand + 'charity/' + npid + '/xo/create';
    const isLoggedIn = !(
      this.props.authState === 'ANONYMOUS' ||
      this.props.authState === 'IDENTIFIED'
    );
    const isMerchant = this.props.userType === 'BUSINESS';
    const unifiedLoginURL = this.props.unifiedLoginURL;
    const charityType = get(charity, 'charity_type', 'PPGF').toUpperCase();
    const isUnEnrolled =
      charityType === 'EXTERNAL' || charityType === 'GUIDESTAR';
    const npoFbDesc1 = i18n('label.social-profile-description1');
    const npoFbDesc2 = i18n('label.social-profile-description2');
    const fbDesc = npoFbDesc1.concat(' ', charity.name, ' ', npoFbDesc2);

    let categories = [];
    if (Array.isArray(this.props.cause_area)) {
      categories =
        uniq(
          this.props.cause_area.map(causeArea =>
            i18n(`label.category-${causeArea.id}`)
          )
        ) || [];
    }
    let link;
    if (this.props.website_url) {
      link = (
        <Link
          onClick={this.handleAnalyticsWebLink}
          target={'_blank'}
          href={this.props.website_url}
          className={styles.linkStyle}
        >
          <Icon name='browser' />
          <CaptionText className={styles.viewWebsite} size='sm' strong>
            {i18n('label.view-website')}
          </CaptionText>
        </Link>
      );
    }

    let ein;
    if (this.props.ein) {
      const einLabel = !isEmpty(charityContent.einLabel)
        ? `${i18n(charityContent.einLabel)} `
        : '';
      ein = (
        <CaptionText as='p' size='md'>
          {einLabel}
          <span>{this.props.ein}</span>
        </CaptionText>
      );
    }

    const address = this.props.address;
    const cityState = (
      <CaptionText as='p' size='md'>
        {[address.city, address.state]
          .map(x => (x || '').trim())
          .filter(x => !!x)
          .join(', ')}
      </CaptionText>
    );

    let source;
    if (charityContent.source) {
      source = (
        <CaptionText as='p' size='md'>
          {`${i18n(charityContent.sourceLabel)}`}&nbsp;
          <span style={{ fontWeight: 'bold' }}>
            {i18n(charityContent.source)}
          </span>
        </CaptionText>
      );
    }

    const isDescription = !!this.props.description;

    const about = (
      <div className={'panel'}>
        <div>
          <HeadingText as='h1' size='md' className={styles['npo-charityTitle']}>
            {i18n('label.about-this-charity')}
          </HeadingText>
          {isDescription && (
            <BodyText as='p' size='md'>
              {this.props.description}
            </BodyText>
          )}
          <div
            style={{
              padding: `${isDescription ? '24px 0px 12px 0px' : '0px'}`,
            }}
          >
            {categories.map((category, categoryIndex) => {
              if (categoryIndex === categories.length - 1) {
                return (
                  <Link
                    onClick={this.handleAnalyticsCategory.bind(this, category)}
                    key={`np-${npid}-${categoryIndex}`}
                    href={`${this.props.resources.searchLink}?category=${category}`}
                  >
                    <BodyText
                      as='p'
                      size='md'
                      regular
                      className={styles.categoryDisplay}
                    >
                      {category}
                    </BodyText>
                  </Link>
                );
              } else {
                return (
                  <span>
                    <Link
                      onClick={this.handleAnalyticsCategory.bind(
                        this,
                        category
                      )}
                      key={`np-${npid}-${categoryIndex}`}
                      href={`${this.props.resources.searchLink}?category=${category}`}
                    >
                      <BodyText
                        as='p'
                        size='md'
                        regular
                        className={styles.categoryDisplay}
                      >
                        {category}
                      </BodyText>
                    </Link>
                    ,{' '}
                  </span>
                );
              }
            })}
          </div>
          <div className={'aboutHelp'}>
            {ein}
            {cityState}
            {link}
            {source}
          </div>
        </div>
      </div>
    );

    const donate = (
      <div className={`panel ${styles.donateBoxPanel}`}>
        <DonateBox
          {...this.props}
          enable={true}
          i18n={i18n}
          formUrl={formUrl}
          charity={this.props.charity}
          fptiInfo={this.state.fptiInfo}
          label_alltocharity={i18n('label.all-to-charity')}
          cdnHost={this.props.cdnHost}
        />
        {this.renderDonationTerms()}
      </div>
    );

    const setPreferred =
      isCountrySetPreferredSupported && !isUnEnrolled ? (
        <>
          {isMerchant ? null : (
            <div className={`panel ${styles['set-preferred-panel']}`}>
              {this.state.isLoading ? (
                <div className={styles['flex-center']}>
                  <Spinner size='md' />
                </div>
              ) : (
                <div className={styles['heart-content']}>
                  <Link
                    data-nemo={!isLoggedIn ? 'npo-heart-link' : undefined}
                    href={
                      !isLoggedIn
                        ? utils.getUnifiedLoginURL(unifiedLoginURL, [
                            {
                              key: 'setPreferred',
                              value: 'true',
                            },
                          ])
                        : undefined
                    }
                    leftIcon={
                      <SetPreferredHeart selected={this.state.heartSelected} />
                    }
                    onClick={() => {
                      if (isLoggedIn) {
                        this.setPreferredFetch();
                      }
                    }}
                  >
                    {this.state.heartSelected
                      ? i18n('label.preferred-charity')
                      : i18n('label.set-preferred')}
                  </Link>
                  {!this.state.heartSelected && (
                    <Tooltip
                      trigger={
                        this.state.isMobile ? 'click' : 'mouseenter focus'
                      }
                      description={i18n('label.setPref-toolTip')}
                    />
                  )}
                </div>
              )}
              {this.state.heartError ? (
                <div className={styles['alert-margin']}>
                  <Alert type='attention'>
                    {i18n('label.setPref-errorAlert')}
                  </Alert>
                </div>
              ) : null}
            </div>
          )}
        </>
      ) : null;

    const benefits = (
      <>
        {isPPGF(allowedCharityType) && (
          <div className={'panel'}>
            <Benefits
              i18n={i18n}
              layout={'vertical'}
              percentToCharity={'100%'}
              cdnHost={this.props.cdnHost}
            />
          </div>
        )}
      </>
    );

    const social = (
      <div className={'panel'}>
        <HubSocialShare
          i18n={i18n}
          fbTitle={charity.name}
          url={`https://www.${this.props.domain}/${charity.address.country_code}/fundraiser/charity/${npid}`}
          fptiInfo={this.state.fptiInfo}
          fbDesc={fbDesc}
          cdnHost={this.props.cdnHost}
        />
        <div className={styles['center-text']}>
          <BodyText style={{ marginBottom: '10px' }} as='p' size='md' strong>
            {i18n('label.spread-the-word')}
          </BodyText>
          <CaptionText size='md'>{i18n('label.share-message')}</CaptionText>
        </div>
      </div>
    );

    const errorAlert = this.renderError();

    return (
      <div>
        {this.props.mppHeader && this.renderHeader()}
        <div className={'cause-viewport'}>
          <div>
            <div className={'cause-charity-hero'} />
            <div className={styles['new-search-container']}>
              <Link href='/fundraiser/hub'>{i18n('label.new-search')}</Link>
            </div>
            <CharityLogo {...this.props} i18n={i18n} />
            <div style={{ maxWidth: '1024px', margin: 'auto' }}>
              <MediaQuery minWidth={901}>
                <Row>
                  <Col xs={7} md={7} lg={7}>
                    {about}
                    {benefits}
                  </Col>
                  <Col xs={5} md={5} lg={5}>
                    {setPreferred}
                    {donate}
                    {social}
                  </Col>
                </Row>
              </MediaQuery>
              <MediaQuery minWidth={601} maxWidth={900}>
                <Row>
                  <Col xs={6} md={6} lg={6}>
                    {about}
                    {benefits}
                  </Col>
                  <Col xs={6} md={6} lg={6}>
                    {setPreferred}
                    {donate}
                    {social}
                  </Col>
                </Row>
              </MediaQuery>
              <MediaQuery maxWidth={600}>
                {about}
                <SheetTrigger
                  TriggerComponent={
                    <Button className={styles['sheet-trigger-button']}>{`${i18n(
                      'label.donate-button'
                    )}`}</Button>
                  }
                  sheetProps={{
                    title: `${i18n('label.donate-button')}`,
                    divider: true,
                  }}
                >
                  {donate}
                </SheetTrigger>
                {setPreferred}
                {benefits}
                {social}
              </MediaQuery>
            </div>
            {/* {isPPGF(allowedCharityType) && (
              <FAQBanner fptiInfo={this.state.fptiInfo} i18n={i18n} />
            )} */}
            <div>
              <div className={'npo-gifts-do-more'}>
                <CaptionText
                  className={'recieptInfo'}
                  dangerouslySetInnerHTML={{
                    __html: isPPGF(allowedCharityType)
                      ? i18n(charityContent.legalDisclaimer)
                      : i18n('label.legal-footer-default'),
                  }}
                  as='p'
                  size='sm'
                />
              </div>
            </div>
          </div>
        </div>
        {errorAlert}
        {this.props.mppFooter && this.renderFooter()}
      </div>
    );
  }
}

const charity = JSON.parse(document.getElementById('charity-props').innerHTML);
const data = JSON.parse(document.getElementById('data-props').innerHTML);
const donationInfo = JSON.parse(
  document.getElementById('donation-info-props').innerHTML || '{}'
);
const states = JSON.parse(document.getElementById('states-props').innerHTML);
const amounts = JSON.parse(document.getElementById('amount-props').innerHTML);
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);
const csrf = document.getElementById('data-csrf').innerHTML;
const coBrand = document.getElementById('data-co-brand').innerHTML;
const hubUrl = `${coBrand}hub`;
const resources = JSON.parse(
  document.getElementById('data-resources').innerHTML
);
const mppFooter = data.mppFooter;
const mppHeader = data.mppHeader;
const allowedCharityType = data.allowedCharityType;
const isThisCharityTheirPreferred = data.isThisCharityTheirPreferred;
const authState = data.authState;
const userType = data.userType;
const unifiedLoginURL = data.unifiedLoginURL;
const isCountrySetPreferredSupported = data.isCountrySetPreferredSupported;
const cdnHost = data.cdnHost;
const domain = data.domain;

ReactDOM.render(
  <DataContext.Provider value={data}>
    <Page
      {...charity}
      id={'nemo_npo'}
      charity={charity}
      donationInfo={donationInfo}
      states={states}
      csrf={csrf}
      fptiInfo={fptiInfo}
      coBrand={coBrand}
      amounts={amounts}
      hubUrl={hubUrl}
      resources={resources}
      mppFooter={mppFooter}
      mppHeader={mppHeader}
      unifiedLoginURL={unifiedLoginURL}
      userType={userType}
      isThisCharityTheirPreferred={isThisCharityTheirPreferred}
      authState={authState}
      isCountrySetPreferredSupported={isCountrySetPreferredSupported}
      cdnHost={cdnHost}
      domain={domain}
    />
  </DataContext.Provider>,
  document.getElementById('page')
);
